import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6128ceed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-organization" }
const _hoisted_2 = { class: "steps" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Gebe deinem Chatbot einen Namen", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, [
  /*#__PURE__*/_createTextVNode(" Der Name deines Chatbots dient dir zu Identifikation. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Dieser Name wird nicht öffentlich angezeigt. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Deine kostenlose Testversion", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Keine Verpflichtungen. Teste ChatCaptain 14 Tage lang kostenlos und unverbindlich. Nach ablauf der 14 Tage kannst du ein Abonnement wählen. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "0 € für 14 Tage", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "description",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createTextVNode(" 2.500 Interaktionen enthalten"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" + alle Business Funktionen ")
], -1))
const _hoisted_9 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_step = _resolveComponent("step")!
  const _component_md_card = _resolveComponent("md-card")!
  const _component_stepper = _resolveComponent("stepper")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_overlay = _resolveComponent("md-overlay")!

  return (_openBlock(), _createBlock(_component_md_overlay, {
    title: "Neuen Chatbot erstellen",
    ref: "overlay"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, "Schritt " + _toDisplayString(_ctx.step) + " von 2", 1),
        _createVNode(_component_stepper, {
          ref: "stepper",
          onChange: _ctx.onStepperChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_step, { index: 0 }, {
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4,
                _createVNode(_component_md_input_field, {
                  required: "",
                  variant: "filled",
                  modelValue: _ctx.chatbotName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chatbotName) = $event)),
                  label: "Name des Chatbots",
                  ref: "nameInput",
                  onKeydown: _withKeys(_ctx.goToNextStep, ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            }),
            _createVNode(_component_step, { index: 1 }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6,
                _createVNode(_component_md_card, { variant: "outlined" }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onChange"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_md_button, {
            variant: "text",
            disabled: _ctx.step === 1,
            grey: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stepper.prev()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Zurück")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_md_button, {
            variant: "filled",
            onClick: _ctx.goToNextStep
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.step === 1 ? "Weiter" : "Jetzt loslegen"), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 512))
}